import { useLocation } from 'wouter';
import { useAdminAuth } from '@/contexts/AdminAuthContext';
import { areaForPath } from '@/lib/adminAreas';
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@/components/ui/command';
import {
  LayoutDashboard,
  Megaphone,
  PartyPopper,
  MapPin,
  BarChart3,
  Hotel,
  Package,
  Users,
  UserCheck,
  Map,
  ScrollText,
  Settings,
  ShieldAlert,
  Route,
  TrendingUp,
  FileCheck,
  History,
  Siren,
  TrafficCone,
  Compass,
  Inbox,
  Network,
} from 'lucide-react';

interface CommandPaletteProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const pages = [
  { label: 'Overview', href: '/admin', icon: LayoutDashboard },
  { label: 'Sponsors', href: '/admin/sponsors', icon: Megaphone },
  { label: 'Festivals', href: '/admin/festivals', icon: PartyPopper },
  { label: 'Explore Destinations', href: '/admin/explore', icon: Compass },
  { label: 'Listings', href: '/admin/listings', icon: MapPin },
  { label: 'B2G Dashboard', href: '/admin/dashboard', icon: BarChart3 },
  { label: 'Revenue', href: '/admin/revenue', icon: TrendingUp },
  { label: 'Live Map', href: '/admin/live-map', icon: Map },
  { label: 'Ride History', href: '/admin/ride-history', icon: History },
  { label: 'Concierge', href: '/admin/concierge', icon: Hotel },
  { label: 'Corridors', href: '/admin/corridors', icon: Route },
  { label: 'Packages', href: '/admin/packages', icon: Package },
  { label: 'Drivers', href: '/admin/drivers', icon: Users },
  { label: 'Passengers', href: '/admin/passengers', icon: UserCheck },
  { label: 'Driver Verification', href: '/admin/verification', icon: FileCheck },
  { label: 'Trust & Safety', href: '/admin/incidents', icon: ShieldAlert },
  { label: 'Road Status', href: '/admin/road-status', icon: TrafficCone },
  { label: 'Island Alerts', href: '/admin/alerts', icon: Siren },
  { label: 'Audit Log', href: '/admin/audit', icon: ScrollText },
  { label: 'Requests', href: '/admin/requests', icon: Inbox },
  { label: 'Team', href: '/admin/team', icon: Network },
  { label: 'Settings', href: '/admin/settings', icon: Settings },
];

export default function CommandPalette({ open, onOpenChange }: CommandPaletteProps) {
  const [, setLocation] = useLocation();
  const { canAccess } = useAdminAuth();

  const navigate = (href: string) => {
    setLocation(href);
    onOpenChange(false);
  };

  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput placeholder="Search pages, actions..." className="text-white" />
      <CommandList>
        <CommandEmpty>No results found.</CommandEmpty>
        <CommandGroup heading="Pages">
          {pages.filter((page) => canAccess(areaForPath(page.href))).map((page) => {
            const Icon = page.icon;
            return (
              <CommandItem
                key={page.href}
                onSelect={() => navigate(page.href)}
                className="cursor-pointer"
              >
                <Icon className="w-4 h-4 mr-2 text-gray-400" />
                <span>{page.label}</span>
              </CommandItem>
            );
          })}
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
}
